export default __webpack_public_path__ + "svg/calendar/2027/4/abril.svg?cb9b619d";